import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button, Input, Select } from '@ipc/ipc-components';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import locale from 'date-fns/locale/en-US';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { putBOHTransactionsEditRequestActionCreator } from '../redux/actions/BalanceModificationTransactionsEditActions';
import { getAssetType } from '../../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { getImpcsOfSingleInboundOperatorRequestActionCreator } from '../../../../../../common/selection-criteria/impcs-per-operator/redux/actions/ImpcsOfSingleOperatorActions';
import {
  getInboundImpcsOfSingleOperator,
  getLeftPostalOperatorsCodesOnly,
} from '../../../../../../common/user/redux/selectors/UserDataSelectors';

if (locale && locale.options) {
  locale.options.weekStartsOn = 1;
}

class BalanceModificationTransactionsEditDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: props.row.row.comment,
      adjustment: props.row.row.adjustment,
      effectiveDateTime: props.row.row.when,
      impcCode: props.row.row.impc,
      operatorCode: props.row.row.operator,
      transactionId: props.row.row.id,
      description: props.row.row.reason,
      isCommentRequired: false,
    };
    this.handleNewOperator = this.handleNewOperator.bind(this);
    this.handleNewIMPC = this.handleNewIMPC.bind(this);
    this.handleAdjustment = this.handleAdjustment.bind(this);
    this.handleDescription = this.handleDescription.bind(this);
    this.handleComments = this.handleComments.bind(this);
    this.handleEffectiveDateTime = this.handleEffectiveDateTime.bind(this);
    this.confirmEdit = this.confirmEdit.bind(this);
    this.props.getImpcsOfSingleInboundOperatorRequestActionCreator(this.props.appContext.appContext, props.row.row.operator);
  }

  isFormValid = () => !(this.state.adjustment === '' || this.state.effectiveDateTime === 'Invalid date' || this.state.impcCode === 'Select IMPC'
    || (this.state.isCommentRequired && this.state.comments === '') || ((this.state.description === 'Other') && (this.state.comments === '')))

  handleNewOperator(selectedOption) {
    this.props.getImpcsOfSingleInboundOperatorRequestActionCreator(this.props.appContext.appContext, selectedOption.value);
    this.setState({
      operatorCode: selectedOption.value,
      impcCode: 'Select IMPC',
    });
  }

  handleNewIMPC(selectedOption) {
    this.setState({
      impcCode: selectedOption.value,
    });
  }

  handleAdjustment(e) {
    this.setState({
      adjustment: e.target.value,
    });
  }

  handleDescription(option) {
    this.setState({
      description: option.label,
      isCommentRequired: option.label === 'Other',
    });
  }

  handleComments(e) {
    this.setState({
      comments: e.target.value,
    });
  }

  handleEffectiveDateTime(date) {
    const newDate = moment(date);
    this.setState({
      effectiveDateTime: newDate.format('YYYY-MM-DD HH:mm:ss'),
    });
  }

  mapImpcListToSelectOptions(listToMappedOptions) {
    const mappedList = [];
    listToMappedOptions.map((item) => {
      const impc = {
        label: item,
        value: item,
      };
      return mappedList.push(impc);
    });
    return mappedList;
  }

  async confirmEdit() {
    await this.props.putBOHTransactionsEditRequestActionCreator(
      this.props.appContext,
      this.state.adjustment,
      this.state.comments,
      this.state.description,
      this.state.effectiveDateTime,
      this.state.impcCode,
      this.state.operatorCode,
      this.state.transactionId,
    );
    this.props.closeDialog();
    await this.props.refreshTransactions();
    this.props.refreshHistories();
  }

  render() {
    const options = [
      { label: 'Damaged trays' },
      { label: 'New trays' },
      { label: 'Annual adjustment' },
      { label: 'Trays found' },
      { label: 'Other' }];
    const bagOptions = [
      { label: 'Damaged Bags' },
      { label: 'New Bags' },
      { label: 'Annual adjustment' },
      { label: 'Bags found' },
      { label: 'Other' }];
    const palletOptions = [
      { label: 'Damaged Pallets' },
      { label: 'New Pallet Boxes' },
      { label: 'Annual adjustment' },
      { label: 'Pallet Boxes found' },
      { label: 'Other' }];
    return (
      <Dialog onClose={this.props.closeDialog} aria-labelledby="simple-dialog-title" open={this.props.openDialog}>
        <DialogTitle id="simple-dialog-title">Edit Transaction</DialogTitle>
        <div style={{ float: 'left' }}>
          <table className="operator-impc-detail">
            <tbody>
              <tr>
                <td className="selected-impc">
                  Operator
                </td>
                <td className="selected-impc">
                  <Select
                    value={this.state.operatorCode}
                    placeholder={this.state.operatorCode}
                    options={this.props.operatorOptions}
                    onChange={this.handleNewOperator}
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  IMPC
                </td>
                <td className="selected-impc">
                  <Select
                    value={this.state.impcCode}
                    placeholder={this.state.impcCode}
                    options={this.mapImpcListToSelectOptions(this.props.impcList)}
                    onChange={this.handleNewIMPC}
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Adjustment
                </td>
                <td className="selected-impc">
                  <Input type="number" value={this.state.adjustment} onChange={this.handleAdjustment} />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Effective date & time
                </td>
                <td className="selected-impc">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDateTimePicker
                        autoOk
                        disableToolbar
                        variant="inline"
                        format="dd-MM-yyyy HH:mm"
                        ampm={false}
                        margin="normal"
                        id="date-picker-inline"
                        value={this.state.effectiveDateTime}
                        onChange={this.handleEffectiveDateTime}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Description
                </td>
                <td className="selected-impc">
                  {this.props.appContext.appContext === 'tray' && (
                    <Select
                      value={this.state.description}
                      placeholder={this.state.description}
                      options={options}
                      onChange={this.handleDescription}
                    />
                  )}
                  {this.props.appContext.appContext === 'bag' && (
                    <Select
                      value={this.state.description}
                      placeholder={this.state.description}
                      options={bagOptions}
                      onChange={this.handleDescription}
                    />
                  )}
                  {this.props.appContext.appContext === 'pallet' && (
                    <Select
                      value={this.state.description}
                      placeholder={this.state.description}
                      options={palletOptions}
                      onChange={this.handleDescription}
                    />
                  )}
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Comment
                </td>
                <td className="selected-impc">
                  <Input
                    value={this.state.comments}
                    onChange={this.handleComments}
                    placeholder={this.state.isCommentRequired ? 'Please enter a comment' : ''}
                    maxLength={45}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="after-box">
          <Button style={{ marginLeft: '25px', marginBottom: '10px' }} onClick={this.props.closeDialog}>Cancel</Button>
          <Button
            style={{ float: 'right', marginRight: '50px', marginBottom: '10px' }}
            onClick={this.confirmEdit}
            className={`primary-button-${!this.isFormValid()}`}
            disabled={!this.isFormValid()}
          >
            Confirm
          </Button>
        </div>
      </Dialog>
    );
  }
}

BalanceModificationTransactionsEditDialog.propTypes = {
  row: PropTypes.objectOf(PropTypes.shape),
  appContext: PropTypes.objectOf(PropTypes.shape),
  impcList: PropTypes.arrayOf(PropTypes.string),
  operatorOptions: PropTypes.arrayOf(PropTypes.object),
  putBOHTransactionsEditRequestActionCreator: PropTypes.func,
  getImpcsOfSingleInboundOperatorRequestActionCreator: PropTypes.func,
  openDialog: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    appContext: getAssetType(state),
    impcList: getInboundImpcsOfSingleOperator(state),
    operatorOptions: getLeftPostalOperatorsCodesOnly(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  putBOHTransactionsEditRequestActionCreator,
  getImpcsOfSingleInboundOperatorRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BalanceModificationTransactionsEditDialog);
